<template>
  <b-modal id="mass-period-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('catalog.set_new_period') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="d-flex align-items-center mr-4" :class="{'catalog-switched': toggle}" v-if="activities.length > 1">
        <p class="mb-0 mr-2 catalog-switch-text">{{ $t('catalog.common_for_all') }}</p>
        <b-form-checkbox style="margin-bottom: 7px" switch size="lg" @change="changeToggle($event)" checked="true" />
      </div>
      <div class="adp-modal-row d-flex flex-column">
        <template v-if="toggle">
          <label class="adp-p adp-p__grey mb-1 mt-4" v-if="activities.length === 1">{{ activities[0].name }}</label>
          <my-date-picker @change="changeCommonPeriod($event)"
                          :dates="commonPeriod"
                          :range="true"
                          :not-disable-range="true"
                          :clearable="false"
          >
          </my-date-picker>
        </template>
        <template v-else>
          <div v-for="activity in activities" :key="activity.id">
            <label class="adp-p adp-p__grey mb-1 mt-4">{{ activity.name }}</label>
            <my-date-picker @change="changeActivityPeriod($event, activity)"
                            :dates="activityPeriods[activity.id]"
                            :range="true"
                            :not-disable-range="true"
                            :clearable="false"
            >
            </my-date-picker>
          </div>
        </template>
      </div>
    </template>
    <template #modal-footer>
      <button class="btn adp-btn adp-btn__large"
              :class="{'disabled': disabled}"
              :disabled="disabled"
              style="margin-left: auto"
              @click="save()">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import MyDatePicker from "../MyDatePicker";
import api from "../../api";

export default {
  name: "ChangeDeadlineModal",
  components: {
    'my-date-picker': MyDatePicker,
  },
  props: {
    activities: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      commonPeriod: null,
      activityPeriods: {},
      toggle: true,
      disabled: true,
    }
  },
  computed: {

  },
  methods: {
    onShow() {
      this.toggle = true;
      this.disabled = true;
      this.commonPeriod = null;
      this.activityPeriods = {};

    },
    changeCommonPeriod(e) {
      if (e === null) {
        return;
      }
      this.commonPeriod = e;

      if (this.commonPeriod) {
        this.disabled = false;
      }
    },
    changeActivityPeriod(e, activity) {
      if (e === null) {
        return;
      }
      this.activityPeriods[activity.id] = e;

      if (Object.keys(this.activityPeriods).length === this.activities.length) {
        this.disabled = false;
      }
    },
    changeToggle(e) {
      this.toggle = e;
    },
    async save() {
      const data = {};

      if (this.toggle) {
        data.ids = [...this.activities.map(item => item.id)];
        data.start_at = new Date(this.commonPeriod[0]).toLocaleString();
        data.end_at = new Date(this.commonPeriod[1]).toLocaleString();
      } else {
        data.events = [...this.activities.map(item => {
          return {
            id: item.id,
            start_at: new Date(this.activityPeriods[item.id][0]).toLocaleString(),
            end_at: new Date(this.activityPeriods[item.id][1]).toLocaleString(),
          }
        })];
      }

      await api.setCatalogActivitiesPeriod(data);
      await this.$bvModal.hide('mass-period-modal');
      await this.$emit('period-updated');
    },
  },
}
</script>
